// extracted by mini-css-extract-plugin
export default {"container":"styles_container__6iLuI","shipmentsList":"styles_shipmentsList__z0tJb","footer":"styles_footer__29rmc"};